// extracted by mini-css-extract-plugin
export var barContainer = "_w-0";
export var extraThin = "_w-3";
export var fillBar = "_w-6";
export var fillContainer = "_w-4";
export var overflow = "_w-8";
export var overflowContainer = "_w-5";
export var regular = "_w-7";
export var thick = "_w-1";
export var thin = "_w-2";